<template>
    <div>
        
        <WisdomToothExtraction />
    </div>
</template>

<script>

import WisdomToothExtraction from '../blog-details/WisdomToothExtraction.vue'

export default {
    components: {
        
        WisdomToothExtraction,
    }
}
</script>